import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import frTranslation from '../../../assets/i18n/fr.json';

export class TranslateInMemoryLoader implements TranslateLoader {
  /**
   * Gets the translations directly from the json file, so that
   * no HTTP request is needed to get them.
   *
   * Drawback: the bundle is slightly bigger.
   *
   * Works thanks to "resolveJsonModule": true and "esModuleInterop": true
   */
  public getTranslation(lang: string): Observable<Object> {
    return of(frTranslation);
  }
}
